const Tooltip = () => (
  <>
    <span className="absolute bottom-[calc(100%+5px)] left-1/2 mb-2 hidden -translate-x-1/2 whitespace-nowrap rounded bg-gray-100 p-2 text-xs text-black shadow group-hover:inline-block xs:block">
      Other option(s) available
    </span>
    <span className="border-t-blue-300group-hover:inline-block absolute bottom-full left-1/2 mb-2 hidden -translate-x-1/2 border-[6px] border-b-0 border-l-transparent border-r-transparent xs:block"></span>
  </>
);

export default Tooltip;
